module.exports = __webpack_public_path__ + "static/img/trifol02-jpeg.76354e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/LARD/trifol02-jpeg.png
// module id = s9Fz
// module chunks = 1